import React, { useState } from 'react'
import { useDispatch, connect } from 'react-redux'
import { Field, FieldArray, reduxForm, change } from 'redux-form'
import styles from './TkAndCrpForms.css'
import { green } from '@material-ui/core/colors'
import {
  InputLabel,
  FormControlLabel,
  MenuItem,
  FormControl,
  Link,
  Checkbox,
  Select as SelectField,
} from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles'
import MaskedInput from '../../containers/Forms/components/CrpMaskedInput'
import CheckboxInput from '../../containers/Forms/components/CheckboxInput'
import FormSection from 'views/components/Common/FormSection/FormSection'
import CheckedIcon from 'static/images/icons/checkboxCheckedSquare.svg'
import UncheckedIcon from 'static/images/icons/checkboxUncheckedSquare.svg'
import CheckedDisabledIcon from 'static/images/icons/checkboxCheckedDisableSquare.svg'
import RadioButtonAvailability from './components/RadioButtonAvailability'
import { DATASOURCES } from '../../constants'
import { getDataSource } from '../../store/appReducer'
import {
  emailMask,
  requiredValidation,
  emailValidation,
  minLen1Validation,
  phoneValidationWith1Prefix,
  isValidNPI,
  castStringBooleanToBoolean,
} from '../../containers/Forms/components/formValidations'
import TextInput from '../../containers/Forms/components/CrpTextInput'
import Loading from '../../components/Loading'
import AppNotification from 'views/components/AppNotification/AppNotification'
import pluseIcon from 'static/images/Vector.png'
import { countryList, RegionList, AVAILABILITY } from './constants'
import { LICENSE_COVERED_AREAS, LICENSE_COVERED_COUNTRIES, LICENSE_COVERED_EU_REGION_COUNTRIES, getRegion } from 'legacy/constants'
import { ToastContainer, toast } from 'react-toastify'
import CustomModal from '../../../views/components/Modal/CustomModal'
import WarningIcon from '../../../static/images/Warning.png'
import ToastWithCancel from '../../../views/components/Modal/Alert'

const NewMemberForm = props => {
  const [ required, setRequired ] = useState(false)
  const [ userType, setUserType ] = useState(1)
  const [ openModal, setOpenModal ] = useState(false)
  const dispatch = useDispatch()
  const {
    handleSubmit,
    invalid,
    pristine,
    submitting,
    isSubmitting,
    showTKFeatureEnabled: tkEnabled,
    showCRPFeatureEnabled: crpEnabled,
    showRPMFeatureEnabled: rpmEnabled,
    inviteMemberFormValues,
    successInviteClosed,
    successAlert,
    emailAlert,
    emailTakenClosed,
    reserveData,
  } = props
  const updateUserType = (e, newValue, previousValue, name) => {
    const fieldName = name.split('.')[1]
    let newType = userType
    switch (fieldName) {
    case 'isPhysician':
      newType += (newValue ? 2 : -2)
      break
    case 'isAdmin':
      newType += (newValue ? 3 : -3)
      break
    default:
      break
    }
    // 1 = neither
    // 3 = physician
    // 4 = admin
    // 6 = physician and admin
    setUserType(newType)
  }
  const isAdmin = () => userType === 4
  const isPhysician = () => userType === 3
  const isAdminPhysician = () => userType === 6
  const memberInfoSubHead = 'When you add a team member to your practice, we will send an invite email to the email address provided.'
  const notificationsSubhead = 'Select the notification type the member will receive for an upcoming appointments.'
  const isUsRegion = getRegion() === 'us'
  const coveredRegions = isUsRegion ? LICENSE_COVERED_COUNTRIES : LICENSE_COVERED_EU_REGION_COUNTRIES

  // Member info section implementation on My Info page
  const renderSelectField = withStyles({
    select: {
      height: '10px',
      background: '#FFFFFF',
    },
  })(({
    input,
    label,
    meta: { touched, error },
    children,
    ...custom
  }) => (
    <FormControl size="small" variant="outlined" fullWidth>
      <InputLabel className={styles.label} style={{ marginBottom: '4px' }}>{label}</InputLabel>
      <SelectField
        floatingLabelText={label}
        errorText={touched && error}
        className={styles.selectFieldStyle}
        {...input}
        // eslint-disable-next-line react/no-children-prop
        children={children}
        {...custom}
      />
      {error && <span className={styles.error}>{error}</span>}
    </FormControl>
  ))
  const retryHandler = e => {
    setOpenModal(false)
    setTimeout(() => {
      submitDetails(e)
    }, 300)
  }
  const hideModalNetwork = () => setOpenModal(false)
  // function to submit details and check network issue
  const submitDetails = ev => {
    ev.preventDefault()
    if (window.navigator.onLine) {
      handleSubmit()
    } else {
      setOpenModal(true)
    }
  }
  const closeSuccessToast = () => {
    dispatch(successInviteClosed())
  }
  const closeSuccessToastEmail = () => {
    dispatch(emailTakenClosed())
  }
  const fullName = nameData => {
    return `${nameData.firstName} ${nameData.lastName}`
  }


  return (
    <React.Fragment>
      {(tkEnabled || crpEnabled) && (
        <div>
          <div>
            <ToastWithCancel
              open={successAlert}
              alertMessage={`${reserveData &&
                fullName(
                  reserveData
                )} has been successfully added. An email has been sent to them.`}
              closeHandler={closeSuccessToast}
              severity="success"
            />
          </div>
          <div>
            <ToastWithCancel
              open={emailAlert}
              alertMessage={`${reserveData && reserveData.email} already exists in the system.`}
              closeHandler={closeSuccessToastEmail}
              severity="error"
            />
          </div>
        </div>
      )}
      <form onSubmit={submitDetails} className={styles.updatePasswordForm}>
        <AppNotification />
        <FormSection heading="Member Roles" style={{ padding: '2rem 3rem' }}>
          <div className={styles.formSectionRow}>
            <div className={styles.checkboxWithDesc}>
              <Field
                component={CheckboxInput}
                labelClassName={styles.memberRole}
                label="Provider"
                name="permissions.isPhysician"
                description="Access to Provider functions (e.g. Ordering Provider)"
                onChange={updateUserType}
                checkedIcon={<CheckedIcon className={styles.checkboxIcon}/>}
                uncheckedIcon={<UncheckedIcon className={styles.checkboxIcon} />}
                checkedDisabledIcon={<CheckedDisabledIcon className={styles.disabledCheckboxIcon} />}
                uncheckedDisabledIcon={<UncheckedIcon className={styles.disabledCheckboxIcon} />}
              />
            </div>
            <div className={styles.checkboxWithDesc}>
              <Field
                component={CheckboxInput}
                labelClassName={styles.memberRole}
                label="Account Administrator"
                name="permissions.isAdmin"
                description="Can manage team settings (e.g. add/remove members)"
                onChange={updateUserType}
                checkedIcon={<CheckedIcon className={styles.checkboxIcon}/>}
                uncheckedIcon={<UncheckedIcon className={styles.checkboxIcon} />}
                checkedDisabledIcon={<CheckedDisabledIcon className={styles.disabledCheckboxIcon} />}
                uncheckedDisabledIcon={<UncheckedIcon className={styles.disabledCheckboxIcon} />}
              />
            </div>
          </div>
        </FormSection>

        {(tkEnabled || crpEnabled) && (
          <FormSection
            heading="Member Information"
            subheading={memberInfoSubHead}
            required
          >
            <React.Fragment>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <Field
                    component={TextInput}
                    label="First Name"
                    name="firstName"
                    placeholder="Enter First Name"
                    required
                    validate={[ minLen1Validation, requiredValidation ]}
                  />
                </div>
                <div className={styles.editLabelGroup}>
                  <Field
                    component={TextInput}
                    label="Last Name"
                    name="lastName"
                    placeholder="Enter Last Name"
                    required
                    validate={[ minLen1Validation, requiredValidation ]}
                  />
                </div>
                {(isPhysician() || isAdminPhysician()) && (
                  <div className={styles.editLabelGroup}>
                    <Field
                      component={TextInput}
                      label="NPI (If Applicable)"
                      name="npiNo"
                      placeholder="Enter NPI (If Applicable)"
                      validate={[ isValidNPI ]}
                      type="number"
                    />
                  </div>
                )}
                <div className={styles.editLabelGroup}>
                  <Field
                    component={TextInput}
                    label="Phone"
                    name="phone"
                    placeholder="Enter phone no"
                    validate={isUsRegion ? [ phoneValidationWith1Prefix, tkEnabled ? requiredValidation : null ] : [ requiredValidation ]}
                    type="number"
                    required={tkEnabled}
                  />
                </div>
              </div>
              <div
                className={
                  isUsRegion
                    ? `${styles.formSectionRow}`
                    : `${styles.formSectionRow} ${styles.contentJustify}`
                }
              >
                <div className={styles.editLabelGroup}>
                  <Field
                    component={MaskedInput}
                    mask={emailMask}
                    placeholder="name@example.com"
                    label="Email"
                    name="email"
                    required
                    validate={[
                      emailValidation,
                      minLen1Validation,
                      requiredValidation,
                    ]}
                  />
                </div>
                <div
                  className={
                    !(isPhysician() || isAdminPhysician()) && !isUsRegion
                      ? `${styles.editLabelGroup} ${styles.regionMargin}`
                      : `${styles.editLabelGroup}`
                  }
                >
                  <InputLabel
                    className={styles.label}
                    style={{ marginBottom: '4px' }}
                  >
                    {isUsRegion ? 'Country' : 'Region'}
                  </InputLabel>
                  <Field name="country" component={renderSelectField}>
                    {coveredRegions.map((item, i) => (
                      <MenuItem key={i} value={item.code}>
                        {item.name}
                      </MenuItem>))}
                  </Field>
                </div>
                {isUsRegion && (
                  <div className={styles.editLabelGroup}>
                    <InputLabel
                      className={styles.label}
                      style={{ marginBottom: '4px' }}
                    >
                      State/Region
                    </InputLabel>
                    <Field name="region" component={renderSelectField}>
                      {LICENSE_COVERED_AREAS.map((item, i) => (
                        <MenuItem key={i} value={item.code}>
                          {item.name}
                        </MenuItem>
                      ))}
                    </Field>
                  </div>)}
              </div>
            </React.Fragment>
          </FormSection>
        )}

        {(!tkEnabled && !crpEnabled) && (
          <FormSection
            heading="Member Information"
            subheading={memberInfoSubHead}
            required
          >
            <React.Fragment>
              <div className={styles.formSectionRow}>
                <div className={styles.editLabelGroup}>
                  <Field
                    component={MaskedInput}
                    mask={emailMask}
                    placeholder="name@example.com"
                    label="Email"
                    name="email"
                    required
                    validate={[
                      emailValidation,
                      minLen1Validation,
                      requiredValidation,
                    ]}
                  />
                </div>
              </div>
            </React.Fragment>
          </FormSection>
        )}

        {(isPhysician() || isAdminPhysician()) && (tkEnabled || crpEnabled) && (
          <FormSection
            heading="Manage Availability"
            style={{ padding: '2rem 3rem' }}
          >
            <div className={styles.formSectionRow}>
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={RadioButtonAvailability}
                  name="canManageAvailability"
                  options={AVAILABILITY}
                  props={{ value: AVAILABILITY }}
                  normalize={castStringBooleanToBoolean}
                />
              </div>
              <div className={styles.placeholder} />
            </div>
          </FormSection>
        )}

        {(tkEnabled || crpEnabled) && false && (
          <FormSection
            heading="Appointment Notifications"
            subheading={notificationsSubhead}
          >
            <div
              className={styles.formSectionRow}
              style={{ justifyContent: 'flex-start' }}
            >
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={CheckboxInput}
                  labelClassName={styles.memberRole}
                  label="Text"
                  name="isText"
                  checkedIcon={
                    <CheckedIcon className={styles.checkboxIcon} />
                  }
                  uncheckedIcon={
                    <UncheckedIcon className={styles.checkboxIcon} />
                  }
                  checkedDisabledIcon={
                    <CheckedDisabledIcon
                      className={styles.disabledCheckboxIcon}
                    />
                  }
                  uncheckedDisabledIcon={
                    <UncheckedIcon
                      className={styles.disabledCheckboxIcon}
                    />
                  }
                />
              </div>
              <div className={styles.checkboxWithDesc}>
                <Field
                  component={CheckboxInput}
                  labelClassName={styles.memberRole}
                  label="Email"
                  name="isEmail"
                  checkedIcon={
                    <CheckedIcon className={styles.checkboxIcon} />
                  }
                  uncheckedIcon={
                    <UncheckedIcon className={styles.checkboxIcon} />
                  }
                  checkedDisabledIcon={
                    <CheckedDisabledIcon
                      className={styles.disabledCheckboxIcon}
                    />
                  }
                  uncheckedDisabledIcon={
                    <UncheckedIcon
                      className={styles.disabledCheckboxIcon}
                    />
                  }
                />
              </div>
            </div>
          </FormSection>
        )}

        <div className={styles.submitWrapper}>
          <div className={styles.buttonWrapper}>
            {!pristine && (submitting || isSubmitting) ?
              <button disabled className={styles.submitLoading}>
                <Loading />
              </button>
              :
              <button type="submit" disabled={invalid || pristine || required} className={styles.submit}>
                Send Invite
              </button>
            }
          </div>
        </div>
      </form>
      {(tkEnabled || crpEnabled) && (
        <CustomModal
          modalType="confirm"
          open={openModal}
          closeModalHandler={hideModalNetwork}
          icon={WarningIcon}
          iconAltText="Warning Icon"
          heading="Network Issue"
          descriptionLine1="There was an issue when you attempted to save your changes. Please check your internet"
          descriptionLine2="connection and then try again."
          confirmHandler={e => retryHandler(e)}
          confirmButtonText="TRY AGAIN"
          declineButtonText="CANCEL"
        />
      )}
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  notificationData: getDataSource(state, DATASOURCES.MEMBER_NOTIFICATION_SETTINGS),
})
const decoratedComponent = connect(mapStateToProps, null)(NewMemberForm)
export default reduxForm({ form: 'inviteMemberForm' })(decoratedComponent)



// WEBPACK FOOTER //
// ./src/legacy/containers/Forms/CrpNewMemberForm.jsx